module.exports = __webpack_public_path__ + "media/images/flags/64/Curacao-dc57fec6d49881014f7b024dcbeb8ec3.png";